import { Box, Grid, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { extraordinaryColors } from "../../utils/theme";

export const Landing = () => {
  const navigate = useNavigate();
  const [hoverState, setHoverState] = useState({ index: null, x: 0, y: 0 });

  const handleMouseMove = (event: any, index: any) => {
    const { offsetX, offsetY, target } = event.nativeEvent;
    const width = target.clientWidth;
    const height = target.clientHeight;

    const moveX = ((offsetX - width / 2) / width) * 10;
    const moveY = ((offsetY - height / 2) / height) * 10;

    setHoverState({ index, x: moveX, y: moveY });
  };

  const handleMouseLeave = () => {
    setHoverState({ index: null, x: 0, y: 0 });
  };

  const items = [
    {
      label: "Gift Card Breakage",
      route: "/gift-card",
      color: extraordinaryColors.pink.main
    },
    {
      label: "FBT vs PAYE",
      route: "/fbt-vs-paye",
      color: extraordinaryColors.green.light
    },
    {
      label: "Contribution",
      route: "/contribution",
      color: extraordinaryColors.purple.main
    }
  ];

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: "500px" }}
    >
      {items.map((item, index) => (
        <Grid
          item
          xs={12}
          md={4}
          key={index}
          onMouseMove={(e) => handleMouseMove(e, index)}
          onMouseLeave={handleMouseLeave}
          sx={{
            p: 5,
            textAlign: "center",
            cursor: "pointer"
          }}
          onClick={() => navigate(`${item.route}`)}
        >
          <Box
            sx={{
              display: "inline-block",
              transition:
                "transform 0.2s ease-out, color 0.3s ease, font-weight 0.3s ease",
              transform:
                hoverState.index === index
                  ? `translate(${hoverState.x}px, ${hoverState.y}px)`
                  : "translate(0, 0)",
              fontWeight: hoverState.index === index ? "bold" : "normal",
              color: hoverState.index === index ? item.color : "inherit"
            }}
          >
            <Typography variant="h3">{item.label}</Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
